import React, { useState } from 'react';

import Menu from '~/components/Menu';
import Lista from './Lista';

import { Container } from '~/styles/pagesStyle';
import Footer from '~/components/Footer';

function UserLista() {
  const [loading, setLoading] = useState(false);

  return (
    <Container>
      <Footer />
      <Menu />
      <Lista loading={loading} setLoading={setLoading} />
    </Container>
  );
}

export default UserLista;
